import React, { useEffect } from "react";
import { handleSilentCallback } from "@d-m-organization/hub-shared-lib/auth";

/**
 * Minimal page that runs inside the hidden SSO iframe.
 * Reads the auth code from the URL and posts it to the parent window.
 * Renders nothing visible.
 */
export function SilentCallback() {
  useEffect(() => {
    handleSilentCallback();
  }, []);

  return null;
}
